import { PartyInvolved } from '../../../api/PartiesInvolved';
import { CaseStatus } from '../../../api/cases';

export const updateCaseFields = {
    INVESTIGATOR: "investigator_email",
    SUPERVISING_AUTHORITY: "supervising_authority",
    FORENSIC_AUDITOR: "forensic_auditor",
    EXPOSURE: "exposure",
    PARTIES_INVOLVED: "parties_involved",
    BACKGROUND: "background",
    STATUS: "status",
    LOAN_PRODUCT_INFO: "loan_product_info",
    ACCOUNTS: "accounts",
    EMPLOYEE: "employee_ids",
    FORWARDING_AUTHORITY: "forwarding_authority",
    DEALING_OFFICER: "dealing_authority",
    IO_APP_AUTHORITY: "io_app_authority",
};

export const validateExposure = (exposure: number | undefined): string | null => {
  if (exposure !== undefined && exposure <= 0) {
    return "Fraud Amount must be greater than zero.";
  }
  return null;
};

export const validateBackground = (background: string | undefined): string | null => {
  if (!background || background.trim().length < 100) {
    return "Background must be at least 100 characters long.";
  }
  return null;
};

export const validatePartiesInvolved = (party: PartyInvolved): string | null => {
  if (!party.name || !party.party_type) {
    return "Each party must have a valid Party ID and Name.";
  }
  return null;
};

export const validateStatus = (status: string | undefined): string | null => {
  if (!status || !Object.values(CaseStatus).includes(status as CaseStatus)) {
    return "Please select a valid status";
  }
  return null;
};

export const validateInvestigatorEmail = (email: string | undefined): string | null => {
  if (!email) {
    return "Investigator is required";
  }
  return null;
};

export const validateSupervisingAuthority = (email: string | undefined): string | null => {
  if (!email) {
    return "Competent Authority is required";
  }
  return null;
};

export const validateForwardingAuthority = (value: string | undefined): string | null => {
  if (!value) {
    return "Forwarding Authority is required";
  }
  return null;
};

export const validateDealingOfficer = (value: string | undefined): string | null => {
  if (!value) {
    return "Dealing Officer is required";
  }
  return null;
};

export const validateIOAppointingAuthority = (value: string | undefined): string | null => {
  if (!value) {
    return "IO Appointing Authority is required";
  }
  return null;
};


export const validateForensicAuditor = (value: string | undefined): string | null => {
  if (!value || value.trim().length === 0) {
    return "Forensic Auditor name is required";
  }

  if (value.trim().length < 2) {
    return "Please enter a valid name";
  }

  return null;
}; 